const VL02COLORS = [
  {
    name: "Black",
    mivaname: "black_190",
    hex: "#000000",
    rgb: "rgb(0,0,0)",
    code: "black_190",
    brief: "Jet black, deep and neutral.",
    upcharge: 1.0,
  },
  {
    name: "White",
    mivaname: "white_101",
    hex: "#FFFFFF",
    rgb: "rgb(255,255,255)",
    code: "white_101",
    brief: "Crisp white, bright and clean.",
    upcharge: 1.0,
  },
  {
    name: "Slate Grey",
    mivaname: "slate_grey_830",
    hex: "#9FA4A4",
    rgb: "rgb(159,164,164)",
    code: "slate_grey_830",
    brief: "Cool, soft neutral grey.",
    upcharge: 1.0,
  },
  {
    name: "Pewter",
    mivaname: "pewter_804",
    hex: "#9A9996",
    rgb: "rgb(154,153,150)",
    code: "pewter_804",
    brief: "Subtle, muted grey tone.",
    upcharge: 1.0,
  },
  {
    name: "Almond",
    mivaname: "almond_910",
    hex: "#F5DBB8",
    rgb: "rgb(245,219,184)",
    code: "almond_910",
    brief: "Warm, sandy beige hue.",
    upcharge: 1.0,
  },
  {
    name: "Cocoa",
    mivaname: "cocoa_978",
    hex: "#342016",
    rgb: "rgb(52,32,22)",
    code: "cocoa_978",
    brief: "Rich, dark chocolate brown.",
    upcharge: 1.0,
  },
  {
    name: "Metallic Silver",
    mivaname: "silver_801",
    hex: "#A7A9AC",
    rgb: "rgb(167,169,172)",
    code: "silver_801",
    brief: "Shiny, light metallic grey.",
    upcharge: 1.0,
  },
  {
    name: "Bright Gold",
    mivaname: "gold_213",
    hex: "#A27E24",
    rgb: "rgb(162,126,36)",
    code: "gold_213",
    brief: "Vibrant, warm golden shine.",
    upcharge: 1.0,
  },
  {
    name: "Canary Yellow",
    mivaname: "canary_yellow_220",
    hex: "#FAED26",
    rgb: "rgb(250,237,38)",
    code: "canary_yellow_220",
    brief: "Soft, pale lemon yellow.",
    upcharge: 1.0,
  },
  {
    name: "Sunflower",
    mivaname: "sunflower_240",
    hex: "#FAD626",
    rgb: "rgb(250,214,38)",
    code: "sunflower_240",
    brief: "Bold, sunny yellow glow.",
    upcharge: 1.0,
  },
  {
    name: "Bright Orange",
    mivaname: "orange_360",
    hex: "#E04C00",
    rgb: "rgb(224,076,0)",
    code: "orange_360",
    brief: "Vivid, fiery orange burst.",
    upcharge: 1.0,
  },
  {
    name: "Burgundy",
    mivaname: "burgundy_470",
    hex: "#5A002D",
    rgb: "rgb(98,0,45)",
    code: "burgundy_470",
    brief: "Deep, rich wine red.",
    upcharge: 1.0,
  },
  {
    name: "Red",
    mivaname: "red_417",
    hex: "#E00000",
    rgb: "rgb(224,0,0)",
    code: "red_417",
    brief: "Bold, pure crimson red.",
    upcharge: 1.0,
  },
  {
    name: "Blossom",
    mivaname: "blossom_515",
    hex: "#C4345E",
    rgb: "rgb(196,52,94)",
    code: "blossom_515",
    brief: "Vibrant, rosy pink bloom.",
    upcharge: 1.0,
  },
  {
    name: "Forest Green",
    mivaname: "forest_green_785",
    hex: "#1D6747",
    rgb: "rgb(29,103,71)",
    code: "forest_green_785",
    brief: "Deep, lush evergreen shade.",
    upcharge: 1.0,
  },
  {
    name: "Kelly Green",
    mivaname: "kelly_green_770",
    hex: "#228559",
    rgb: "rgb(34,133,89)",
    code: "kelly_green_770",
    brief: "Bright, emerald green jewel.",
    upcharge: 1.0,
  },
  {
    name: "Vibrant Green",
    mivaname: "vibrant_green_755",
    hex: "#82C551",
    rgb: "rgb(130,197,81)",
    code: "vibrant_green_755",
    brief: "Zesty, lime green vibrance.",
    upcharge: 1.0,
  },
  {
    name: "Teal",
    mivaname: "teal_720",
    hex: "#288AA8",
    rgb: "rgb(40,138,168)",
    code: "teal_720",
    brief: "Cool, balanced teal blend.",
    upcharge: 1.0,
  },
  {
    name: "Dark Blue",
    mivaname: "dark_blue_695",
    hex: "#0F2959",
    rgb: "rgb(15,41,89)",
    code: "dark_blue_695",
    brief: "Deep, midnight navy blue.",
    upcharge: 1.0,
  },
  {
    name: "Vivid Blue",
    mivaname: "vivid_blue_670",
    hex: "#003777",
    rgb: "rgb(0,55,119)",
    code: "vivid_blue_670",
    brief: "Rich, bold medium blue.",
    upcharge: 1.0,
  },
  {
    name: "Olympic Blue",
    mivaname: "olympic_blue_630",
    hex: "#406AD6",
    rgb: "rgb(64,106,214)",
    code: "olympic_blue_630",
    brief: "Soft, serene sea blue.",
    upcharge: 1.0,
  },
  {
    name: "Light Blue",
    mivaname: "light_blue_640",
    hex: "#40A1D6",
    rgb: "rgb(64,161,214)",
    code: "light_blue_640",
    brief: "Gentle, airy sky blue.",
    upcharge: 1.0,
  },
  {
    name: "Purple",
    mivaname: "purple_565",
    hex: "#483182",
    rgb: "rgb(72,49,130)",
    code: "purple_565",
    brief: "Deep, regal purple shade.",
    upcharge: 1.0,
  },
];

// Reflective Colors
const VL03COLORS = [
  {
    name: "White",
    mivaname: "White_7801",
    hex: "#B8C0C3",
    rgb: "rgb(184,192,195)",
    code: "White_7801",
    brief: "Soft, reflective silvery white.",
    upcharge: 1.0,
  },
  {
    name: "Yellow",
    mivaname: "Yellow_7812",
    hex: "#D1A802",
    rgb: "rgb(209,168,2)",
    code: "Yellow_7812",
    brief: "Bright, reflective golden yellow.",
    upcharge: 1.0,
  },
  {
    name: "Dark Red",
    mivaname: "Dark_Red_7818",
    hex: "#BF1623",
    rgb: "rgb(191,022,35)",
    code: "Dark_Red_7818",
    brief: "Deep, reflective ruby red.",
    upcharge: 1.0,
  },
  {
    name: "Green",
    mivaname: "Green_7824",
    hex: "#275F5D",
    rgb: "rgb(39,95,93)",
    code: "Green_7824",
    brief: "Rich, reflective forest green.",
    upcharge: 1.0,
  },
  {
    name: "Blue",
    mivaname: "Blue_7822",
    hex: "#012184",
    rgb: "rgb(1,33,132)",
    code: "Blue_7822",
    brief: "Deep, reflective sapphire blue.",
    upcharge: 1.0,
  },
];

export const COLOR_MAP = {
  VL0200: VL02COLORS,
  VL0300: VL03COLORS,
};

export const getColorsByProductCode = (productCode) => {
  if (!productCode) {
    console.warn("No product code provided");
    return [];
  }
  const colors = COLOR_MAP[productCode];
  if (!colors) {
    console.warn(`No colors defined for product code: ${productCode}`);
    return [];
  }
  return colors;
};
